import { shouldPolyfill } from '@formatjs/intl-numberformat/should-polyfill';

/**
 * Polyfills Intl.NumberFormat if needed, specifically for browsers that don't support
 * newer options like signDisplay: 'negative'
 */
export async function polyfillNumberFormat(): Promise<void> {
  if (shouldPolyfill()) {
    await import('@formatjs/intl-numberformat/polyfill');
    await import('@formatjs/intl-numberformat/locale-data/en');
  }
}
